import Resource from './Resource';

export default class ClassPageAssignmentBin extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let assignmentBinType = '';
		if( options.type === 'course' ){
			assignmentBinType = 'dropboxes';
		}

		if( options.type === 'group' ){
			assignmentBinType = 'student-group-dropboxes';
		}

		if( options.type === 'student' ){
			assignmentBinType = 'student-dropboxes';
		}

		let config = {
			route: `class-pages/:courseSectionGuid/${assignmentBinType}/:assignmentBinId`,
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
